import { render, staticRenderFns } from "./SavedQuotes.vue?vue&type=template&id=331bd4b4"
import script from "./SavedQuotes.vue?vue&type=script&lang=js"
export * from "./SavedQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports